var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-level" }, [
    _c("div", { staticClass: "ellipsis search-result-item gray-100" }, [
      _c("span", [_vm._v(_vm._s(_vm.data.name))])
    ]),
    _vm._v(" "),
    _vm.data.address
      ? _c("div", { staticClass: "ellipsis search-result-item ml-2 gray-60" }, [
          _c("span", [_vm._v(_vm._s(_vm.data.address))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ml-2" },
      [
        _c("tag-rounded", {
          staticClass: "mr-1",
          attrs: {
            label: _vm.tagsHuman[_vm.data.type].label,
            color: _vm.tagsHuman[_vm.data.type].color,
            bgcolor: _vm.tagsHuman[_vm.data.type].bgcolor
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.data.corpid
      ? _c(
          "div",
          { staticClass: "ml-2" },
          [
            _c("tag-rounded", {
              staticClass: "mr-1",
              attrs: {
                label: _vm.thirdCorpid,
                color: "grey-60",
                bgcolor: "gray-05"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.link
      ? _c("div", { staticClass: "flex-right" }, [
          _c("i", { staticClass: "icon-chevron-right gray-60" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }